/**
 * @fileoverview AdsBlock component for the personBy_Id page
 * @active
 *
 * This component displays a waitlist overlay for the personBy_Id page.
 * It allows users to join the waitlist to gain access to exclusive deals and high-potential startups.
 * 
 * @see {@link src/components/ui/WaitlistOverlay.tsx} - Waitlist overlay component
 */

import React, { useState } from 'react';

import { Box, Flex, Image } from '@chakra-ui/react';
import Link from 'next/link';

import { CustomElement } from '@/components/ui/box/CustomElement';
import { RoslindaleText } from '@/components/ui/text/RoslindaleText';
import WaitlistOverlay from '@/components/ui/WaitlistOverlay';

// import { useRouter } from 'next/navigation';

/**
 * AdsBlock component for the personBy_Id page
 * Displays a waitlist overlay for the personBy_Id page
 * 
 * @component
 * @returns {JSX.Element} The AdsBlock component
 */
function AdsBlock() {
  // const router = useRouter();
  // Add state for waitlist overlay visibility
  const [isWaitlistOpen, setIsWaitlistOpen] = useState(false);
  
  // Function to open the waitlist overlay
  const openWaitlist = () => {
    setIsWaitlistOpen(true);
  };
  
  return (
    <>
      <Flex
        justifyContent={'space-between'}
        bgColor={'blue'}
        borderRadius={'10px'}
        p={'20px'}
        minH={{ base: '225px', lg: '137px' }}
      >
        <Flex
          justifyContent={{ base: 'start' }}
          alignItems={{ base: 'start', lg: 'center' }}
          flexDirection={{ base: 'column', lg: 'row' }}
        >
          <RoslindaleText
            customStyle={{
              fontSize: '24px',
              color: 'white',
              maxWidth: '503px',
            }}
          >
            Create your profile now and gain access to exclusive deals and
            high-potential startups.
          </RoslindaleText>
          {/* Replace link with button that opens the waitlist overlay */}
          <CustomElement
            variant={'redBtn'}
            title='Join Early Access'
            customStyle={{
              whiteSpace: 'noWrap',
              mt: { base: '24px', lg: '0px' },
              marginLeft: { base: '0px', lg: '24px' },
            }}
            handler={openWaitlist}
          />
        </Flex>
        <Box margin={'-20px'} display={{ base: 'block', md: 'none', lg: 'none' }}>
          <Image
            src='/images/gazets_mobile.png'
            alt='gazets'
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
        </Box>
        <Box margin={'-20px'} display={{ base: 'none', md: 'block', lg: 'none' }}>
          <Image
            src='/images/gazets_tablet.png'
            alt='gazets'
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
        </Box>
        <Box margin={'-20px'} display={{ base: 'none', md: 'none', lg: 'block' }}>
          <Image
            src='/images/gazets.png'
            alt='gazets'
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
        </Box>
      </Flex>
      
      {/* Add the waitlist overlay without hardcoded company count */}
      <WaitlistOverlay
        isOpen={isWaitlistOpen}
        onClose={() => setIsWaitlistOpen(false)}
      />
    </>
  );
}

export default AdsBlock;
